var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-button',{staticClass:"button-active",attrs:{"loading":_vm.againLoading,"size":"small","round":"","normal":""},on:{"click":_vm.againFun}},[_vm._v("再次购买")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }